/* global FS */
import $ from "jquery";

var recordItemSelector = "tbody:not(.fs-grouphead)>tr,section.td-tile,section.td-kanbancell";

function getHash(href) {
	// When cloning table header IE7 "normalizes" the URL
	// It contains full URL ending with hash, so let's find it by hand
	var n = href.lastIndexOf("#") + 1;
	return href.substring(n);
}

function hasValue(e) {
	if(!e.form || !e.name) return;
	var result = false;
	$(e.form.elements[e.name]).each(function(_i, e) {
		if((e.tagName !== "INPUT" ||
			e.type !== "checkbox" && e.type !== "radio" ||
			e.checked) &&
			$(e).val() !== "")
			return !(result = true);
	});
	return result;
}

function findLabel(e) {
	return e.closest("dl[id$=\"_label\"], td[id$=\"_value\"], div[id$=\"_value\"]");
}

function toggleInvalid(e, toggle) {
	e = $(e);
	var lbl = findLabel(e);

	// control itself is required or label is required and we are checking primary control
	var invalid = (e.attr("required") !== undefined ||
		lbl.hasClass("ui-required") && e.attr("name") === lbl.attr("id").slice(0, -6))
		&& !hasValue(e[0]);

	if(toggle) {
		lbl.toggleClass("ui-invalid", invalid);
		if(!invalid) {
			$("div.ui-alert.ui-popup", lbl).remove();
		}
	}
	else if(invalid)
		lbl.addClass("ui-invalid");
}

const isMacOS = navigator.userAgent.indexOf('Mac OS X') >= 0;

function isNewTab(e) {
	return isMacOS ?
		/*Cmd+Click on mac*/e.metaKey === true :
		/*Ctrl+Click else */e.ctrlKey === true;
}

function init(selector) {

	var lteIE7 = /MSIE [1-7]\b/i.test(navigator.userAgent);

	var ctx = $(selector || "form.fs-form");
	ctx.on("click", "a.fs-setvaluefor", function (e) {
		e = $(e.target);
		var t = $(e.attr("href")), v = e.attr("data-value");
		if (v == null) v = e.text();
		if (t.val() !== v)
			t.val(v).trigger("change");
		return false;
	}).on("focusin focusout", "input,select,textarea,button", function (e) {
		var el = $(e.target), lbl = findLabel(el);
		if (lteIE7) lbl = lbl.add(el);
		lbl.toggleClass("ui-focus", e.type === "focusin");
	});

	// on form init, check for required
	$("input[name], select[name], textarea[name]", ctx).each(function () {
		toggleInvalid(this, false);
	});

	// as change now bubbles we'll attach to form directly
	ctx.on("change", "input[name], select[name], textarea[name]", function () {
		toggleInvalid(this, true);
	});

	ctx.on("click", ".ui-sectiontoggle", function (e) {
		var a = $(this);
		var isCollapsed = a.closest("tbody,section").toggleClass("ui-collapsed").hasClass("ui-collapsed");
		a.toggleClass("ui-icon-expanded", !isCollapsed).toggleClass("ui-icon-collapsed", isCollapsed);
		e.preventDefault();
	});
}

function checkSize(form, size) {
	if (size) {
		var actualSize = 0;
		var data = $(form).serializeArray();
		for (var i = 0; i < data.length; i++)
			actualSize += data[i].name.length + data[i].value.length + 2;
		$("input[type=\"file\"]").each(function () {
			if (this.files) {
				for (i = 0; i < this.files.length; i++) {
					actualSize += this.files[i].size;
				}
			}
		});
		return actualSize < size;
	}
}

function disableButtons(form, enable) {
	if (enable === undefined) {
		// if disable is not explicitly passed, we are submitting. Do not warn.
		window.onbeforeunload = null;
	} else if (enable === false && window.onbeforeunload) {
		// if this is from link click, 5 sec should be enough to leave the page
		// so, reenable the buttons after a while if we are still on the page
		setTimeout(function () { disableButtons(form, true); }, 5000);
	}
	enable = !enable;
	var btn = $('input[type=submit],input[type=reset],button,.ui-button', form).each(function () {
		if (this.tagName === "BUTTON")
			this.disabled = enable;
		$(this).toggleClass("ui-disabled", enable);
	});
	if (enable) {
		$(window).on("unload", $.noop).one("pageshow", function () { btn.prop("disabled", false).removeClass("ui-disabled"); });
	}
}

function onClick (ele) {
	var e = $.event.fix(ele);
	if (e.which !== 1) return;
	var jt = $(e.target).closest("button,a,input[type=checkbox]");
	// do not handle if it is not innermost form
	if (findForm(jt)[0] !== e.currentTarget)
		return;
	var c, nodef = false;
	if (jt.is("button")) {
		if (!jt.prop("disabled")) {
			c = jt.attr("data-confirm");
			if (jt.hasClass("fs-action") || jt.hasClass("fs-multirowaction")) {
				nodef = !postback(jt, jt.attr("value"), c);
			}
			else if (jt.hasClass("fs-rowaction")) {
				nodef = !postbackRow(jt, jt.attr("value"), jt.attr("fs-rowid"), c);
			}
			else if (jt.hasClass("fs-sectionaction")) {
				nodef = !postbackSection(jt, jt.attr("value"), jt.attr("fs-rowid"), c);
			}
		}
	}
	else if (jt.is("input[type=\"checkbox\"]")) {
		if (jt.attr("name") === "rowid") {
			jt.closest(recordItemSelector).toggleClass("ui-state-active", jt.is(":checked"));
			_updateButtons(findForm(jt)[0], "rowid");
		}
		else if (jt.hasClass("fs-selectall")) {
			window.setTimeout(function () { checkRows(jt, "rowid", false); }, 0);
		}
		else if (jt.hasClass("fs-selectgroup")) {
			window.setTimeout(function () { checkRows(jt, "rowid", false, jt.closest("tbody").next("tbody")); }, 0);
		}
	}
	else if (jt.is("a") && !isNewTab(e)) {
		nodef = true;
		if (!jt.hasClass("ui-disabled")) {
			c = confirm(jt.attr("data-confirm"), e);
			nodef = c !== undefined;
			if (c !== false && jt.is("a:not([target]):not([data-download]):not([download]).ui-action.ui-button")) {
				// disable link only if it is like-button
				// does not open in a new frame
				// and does not download
				disableButtons(jt.closest("form"), false);
			}
			if (!nodef) {
				if (jt.hasClass("fs-action") || jt.hasClass("fs-multirowaction")) {
					postback(jt, getHash(jt.attr("href")));
					nodef = true;
				}
				else if (jt.hasClass("fs-cellaction")) {
					postbackCell(jt, jt.attr("name"), getHash(jt.attr("href")));
					nodef = true;
				}
				else if (jt.hasClass("fs-setupcol")) {
					var f = findForm(jt), ff = f[0];
					var l = [];
					if (jt.attr("href") === "#update") {
						c = $(ff["showhidecolumn"]).filter("[type=checkbox]:checked");
						for (var i = 0; i < c.length; i++) {
							l.push(c[i].value);
						}
					}
					postbackCell(f, "showhidecolumn", l.join(","));
					nodef = true;
				}
			}
		}
	}
	if (nodef) {
		e.preventDefault();
	}
}

function findForm (e) {
	/// <param name="e" type="jQuery"/>
	if (!e.length || e.is("form")) return e;
	var f = e[0].form;
	return f != null ? $(f) : e.closest("form");
}

function setFilterPostback(id, action) {
	/// <param name="id" type="String"/>
	/// <param name="action" type="String"/>
	var tr = $("#" + id);
	var i = $("INPUT,SELECT", tr);
	i.on("change", function (e) { postback($(e.target), action, false); });
}

function confirm (c, e) {
	/// <param name="c" type="Boolean"/>
	/// <param name="e" type="DOMEvent"/>
	var b = c == null || c === false || window.confirm(typeof c === "string" && c !== "" ? c : "Are you sure?");
	if (e != null) {
		if (!b) {
			var ee = $.Event(e);
			ee.stopPropagation();
			ee.preventDefault();
			return false;
		}
		return;
	}
	return b;
}

function submit(f, dflt) {
	if (!dflt) f.submit();
	return dflt;
}

function postback (b, actions, confirmText) {
	/// <param name="b" type="jQuery"/>
	/// <param name="actions" type="Object"/>
	/// <param name="confirmText" type="Boolean"/>
	if (confirm(confirmText)) {
		if (typeof actions === "string")
			actions = { postbackaction: actions };
		var f = findForm(b), ff = f[0];
		for (var k in actions) {
			var v = actions[k];
			if (k === "postbackanchor")
				v = ff.name.substring(4) + "_" + v.toString();
			var elt = ff[k];
			if (elt == null)
				f.prepend(elt = $("<input>", { name: k, type: "hidden" }));
			$(elt).val(v);
		}
		if (checkSize(f, window.maxAllowedContentLength) === false) {
			alert("Attached file(s) are too large\r\n\r\n" +
				"Total size of files to send to the server is limited to " + (window.maxAllowedContentLength / (1024 * 1024)).toFixed(0) + "MB\r\n" +
				"* If you are attaching single file, compress it before sending.\r\n" +
				"* If you are attaching multiple files, consider making multiple modifications and attach files one by one.");
			return false;
		}
		return FS.Form.submit(f, b.is("[type=submit]"));
	}
	return false;
}

function postbackSection(b, action, id, confirm) {
	return postback(b, { postbackaction: action, currentrowid: id, postbackanchor: "section_" + id }, confirm);
}

function postbackRow(b, action, id, confirm) {
	return postback(b, { postbackaction: action, currentrowid: id, postbackanchor: id }, confirm);
}

function postbackCell(b, action, id) {
	return postback(b, { postbackaction: action, currentcellid: id }, false);
}

function checkRows(e, name, state, subset) {
	try {
		name = name || "rowid";
		state = e.is(":checked") || !!state;
		var ff = findForm(e)[0];
		subset = $("input[name=\"" + name + "\"],input.fs-selectgroup", subset || ff);
		var c = subset.filter("[type=checkbox]" + (state ? ":not(:checked)" : ":checked")).not(e[0]);
		c.prop("checked", state);
		c.closest(recordItemSelector).toggleClass("ui-state-active", state);
		_updateButtons(ff, name);
	}
	finally {
		document.body.style.cursor = "";
	}
}

function markRows(f, ids) {
	var name = "rowid";
	if (ids.length !== 0) {
		var ff = $(f[name]);
		for (var i = 0; i < ids.length; i++) {
			var c = ff.filter("input[type=\"checkbox\"][value=\"" + ids[i] + "\"]");
			c.prop("checked", true).closest(recordItemSelector).addClass("ui-state-active");
		}
	}
	else {
		_updateButtons(f, name);
	}
}

var _c = 0;

function _updateButtons(f, name) {
	window.clearTimeout(_c);
	_c = window.setTimeout(function () {
		var disabled = !$(f[name]).is(":checkbox:checked");
		$("button.fs-norecords", f).prop("disabled", disabled);
	}, 100);
}

function val(id, value) {
	var n = null;
	for (var i = 0; i < arguments.length; i += 2) {
		id = arguments[i];
		value = arguments[i + 1];
		var o = $("#" + id);
		if (o.val() != value) {
			o.val(value);
			n = n || o;
		}
	}
	if (n != null) {
		n.trigger("change");
	}
	return false;
}

export {
	postback,
	// called by public
	init,
	val,
	onClick,
	disableButtons,
	markRows,
	submit,
	setFilterPostback
};